/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_5372fa5e"]'><div :class='["radio-group-slot-demo"]'><div :class='["cube-radio-group-example"]'><cube-radio-group><cube-radio v-for="(option, index) in (options)" :key="option.index" :option="(option)" :value="checkedValue" mpxModelEvent="input" @mpxModel='(e)=>__invoke(e, [["__model","checkedValue", "__mpx_event__", ["value"], undefined]])'></cube-radio></cube-radio-group></div><div :class='["view-desc"]'>selected value: {{ checkedValue }}</div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_5372fa5e"}'>
.radio-group-slot-demo
  .cube-radio-group-example
    background-color #fff
    padding 5px 10px
  .desc
    margin-top 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_5372fa5e"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_5372fa5e"}
  /** script content **/
  require("./group-slot.mpx.js?isComponent&outputPath=components%2Fgroup-slot5372fa5e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./group-slot.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fgroup-slot5372fa5e%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_5372fa5e"],
    ctorType: "component",
    outputPath: "components/group-slot5372fa5e/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'view-desc':getComponent(require("../../components/desc/index.mpx?isComponent&outputPath=components%2Findex590d50a3%2Findex")),'cube-radio':getComponent(require("../../../packages/mpx-cube-ui/src/components/radio/index.mpx?isComponent&outputPath=components%2Findex4aa5b228%2Findex")),'cube-radio-group':getComponent(require("../../../packages/mpx-cube-ui/src/components/radio-group/index.mpx?isComponent&outputPath=components%2Findex467050cc%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>